import angular from 'angular';
import uiRouter from 'angular-ui-router';
import landingComponent from './landing.component';

let landingModule = angular.module('landing', [
  uiRouter,
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('landing', {
        url: '/',
        template: '<landing class="landing"></landing>',
        resolve: {
          currentUser: (Auth, $state) => {
            return Auth.getCurrentUser()
              .then((user) => {
                return $state.go('engineer.dashboard');
              })
              .catch(data => data);
          },
        }
      });
  })
  .component('landing', landingComponent);

export default landingModule;



// WEBPACK FOOTER //
// ./src/app/screens/guest/screens/landing/index.js